{ isActive, isProcessing, needsCC } = require 'lib/accounts'

module.exports = (paidAccount) ->
  needsCC(paidAccount?.standing) || (isActive(paidAccount) && !isProcessing(paidAccount?.standing))



// WEBPACK FOOTER //
// ./app/scripts/views/billing/internal/is-account-state-known.coffee